import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/articles';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900">
      <div className="mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-fire-line text-2xl text-primary-400"></i>
              </div>
              <span className="font-heading font-bold text-xl text-background-50">
                {siteInfo.name}
              </span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed">
              全网最全吃瓜入口，覆盖51吃瓜官网、黑料吃瓜官网等热门站点，每日推送独家大瓜。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/wanghong-fanche" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">网红翻车</Link>
              <Link to="/category/heila-baoliao" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">黑料爆料</Link>
              <Link to="/category/jieri-dagua" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">今日大瓜</Link>
              <Link to="/category/yule-bagua" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">娱乐八卦</Link>
              <Link to="/category/zhibo-fanche" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">直播翻车</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">关于我们</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">品牌介绍</Link>
              <a href="#newsletter" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">订阅简报</a>
              <Link to="/about" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">联系我们</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">关注我们</h4>
            <div className="flex gap-3">
              <a href={siteInfo.socialLinks.weibo} target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-background-50 text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-background-50 text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-tiktok-line text-background-50 text-lg"></i>
              </a>
            </div>
            <p className="text-foreground-400 text-sm mt-4">
              联系邮箱：{siteInfo.email}
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-500 text-xs">
            &copy; {currentYear} {siteInfo.name} 版权所有 | 内容仅供娱乐参考
          </p>
          <div className="flex items-center gap-4 text-foreground-500 text-xs">
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}